<template>
  <v-layout column fill-height justify-center align-center wrap>
    <v-card class="elevation-0" style="min-width:80%">
      <div class="flex-row">
        <img src="@/assets/images/logo.jpg" alt="alt" class="logo" />
        <br />
      </div>
      <!-- <strong class="pa-2 title pt-3 font-weight-bold flex-row">{{
        $t("APP_NAME")
      }}</strong>-->
      <v-card-text class="text-xs-center mt-2">
        <v-text-field
          v-model="email"
          @keypress="reset"
          :label="$t('email')"
          @keyup.enter="login"
          data-vv-name="email"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
        />
        <v-text-field
          v-model="pass"
          class="flex xs12"
          @keyup.enter="login"
          :label="$t('password')"
          v-validate="'required'"
          data-vv-name="password"
          @click:append="show1 = !show1"
          :type="show1 ? 'text' : 'password'"
          :error-messages="errors.collect('password')"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
        />
        <div class="di-flex mt-3 justify-space-between">
          <v-btn
            class="ma-0"
            @click="login"
            color="btn_color secondary"
            :loading="loading"
            >{{ $t("login") }}</v-btn
          >
          <!-- <v-btn flat @click="error = !error" class="ma-0">
            <strong class="blue--text">رمز خود را فراموش کرده اید؟</strong>
          </v-btn>-->
        </div>
        <div class="py-2 text-xs-center"></div>
      </v-card-text>
      <v-card-actions
        v-show="error.message"
        style="min-width:80%"
        class="grey error--text lighten-4 flex-row"
      >
        <p dir="ltr" class="subheading">{{ error.message }}</p>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LoginPage",
  data: () => ({
    pass: "",
    email: "",
    show1: false,
    loading: false
  }),

  computed: {
    ...mapGetters("AuthModule", {
      authStatus: "authStatus",
      error: "error"
    })
  },
  methods: {
    reset() {
      this.$store.commit("AuthModule/AUTH_RESET");
    },
    login() {
      this.loading = true;
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            const { email, pass } = this;
            this.$store
              .dispatch("AuthModule/AUTH_REQUEST", { email, pass })
              .then(() => {
                setTimeout(() => {
                  this.$router.push("/");
                }, 1000);
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          }
        })
        .catch(() => (this.loading = false));
    }
  }
};
</script>
<style>
.logo {
  width: 200px;
  height: auto;
}
</style>
